/**
 * The Bridge Model — official logo mark.
 *
 * A horizontal suspension bridge crossing into a tunnel,
 * with sunlight visible on the other side.
 *
 * Civic-seal aesthetic. Monochrome navy by default, gold accent for the sun.
 * Designed to read at any size from 24px (favicon) to 240px (hero).
 */
export default function BridgeModelLogo({
  size = 56,
  className = "",
  primary = "#0A192F",
  accent = "#D4AF37",
  sunGlow = "#F4D77A",
  "data-testid": testId = "bridge-model-logo",
  title = "The Bridge Model",
}) {
  return (
    <svg
      viewBox="0 0 280 200"
      width={size}
      height={(size * 200) / 280}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
      data-testid={testId}
    >
      <title>{title}</title>

      {/* Sun rays radiating around / behind the tunnel hill */}
      <g stroke={accent} strokeWidth="2.4" strokeLinecap="round" opacity="0.95">
        <line x1="225" y1="36" x2="225" y2="20" />
        <line x1="252" y1="50" x2="265" y2="40" />
        <line x1="263" y1="85" x2="278" y2="85" />
        <line x1="252" y1="120" x2="265" y2="130" />
        <line x1="238" y1="62" x2="250" y2="56" />
        <line x1="238" y1="108" x2="250" y2="114" />
      </g>

      {/* Tunnel / hill mass — the obstacle the program guides families through */}
      <path
        d="M 165 152 Q 165 48 225 48 Q 285 48 285 152 Z"
        fill={primary}
      />

      {/* Tunnel opening — the path of structured case management */}
      <path
        d="M 195 152 L 195 102 Q 195 78 225 78 Q 255 78 255 102 L 255 152 Z"
        fill={accent}
      />

      {/* Sun visible through the tunnel — stability / sunlight on the other side */}
      <circle cx="225" cy="118" r="11" fill={sunGlow} />

      {/* Bridge approach deck — heading INTO the tunnel */}
      <line
        x1="0"
        y1="152"
        x2="195"
        y2="152"
        stroke={primary}
        strokeWidth="6"
        strokeLinecap="square"
      />

      {/* Suspension cable — top arch */}
      <path
        d="M 12 152 Q 100 64 188 152"
        stroke={primary}
        strokeWidth="3"
        fill="none"
      />

      {/* Vertical suspenders connecting cable to deck */}
      <g stroke={primary} strokeWidth="1.4">
        <line x1="45" y1="152" x2="45" y2="108" />
        <line x1="75" y1="152" x2="75" y2="88" />
        <line x1="105" y1="152" x2="105" y2="79" />
        <line x1="135" y1="152" x2="135" y2="84" />
        <line x1="165" y1="152" x2="165" y2="100" />
      </g>

      {/* Two main piers descending into the water/foundation */}
      <g stroke={primary} strokeWidth="4" strokeLinecap="square">
        <line x1="55" y1="152" x2="55" y2="182" />
        <line x1="145" y1="152" x2="145" y2="182" />
      </g>

      {/* Foundation / water line */}
      <line
        x1="0"
        y1="184"
        x2="285"
        y2="184"
        stroke={primary}
        strokeWidth="1.5"
      />
    </svg>
  );
}
